export default __webpack_public_path__ + "assets/rajasthan_before.jpg";